
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertSql (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/sql',
    method: 'POST',
    data: parameter
  })
}
export function updateSql (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/sql',
    method: 'PUT',
    data: parameter
  })
}
export function deleteSql (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/sql',
    method: 'DELETE',
    params: {
      id: parameter
    }
  })
}
export function getSqlList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/sql',
    method: 'GET',
    params: parameter
  })
}
export function getSqlInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/sql',
    method: 'GET',
    params: parameter
  })
}
// 获取角色下的所有sql
export function getSqlRoleList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/role/list',
    method: 'GET',
    params: parameter
  })
}
// 保存角色数据权限
export function insertSqlRole (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/role',
    method: 'PUT',
    data: parameter
  })
}
